import { default as healthConfiguration } from './health';
import { default as proileConfiguration } from './profile';

export const configurations = [
  healthConfiguration,
  proileConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/system-status/configurations/index.js